import React, { useState, useEffect } from 'react';
import './BannerSlider.css';

const BannerSlider = () => {
  const slides = [
    {
      id: 1,
      tag: 'TECH SOLUTIONS FOR STARTUPS',
      title: 'Delivering Tech Solutions For Your Startups',
      description: 'Empower your startup with cutting-edge technology solutions designed to accelerate growth. From web and mobile development to cloud infrastructure, we provide scalable tech solutions that help startups innovate faster and effectively.',
      rightImage: '/images/main-slider/pic2.jpg'
    },
    {
      id: 2,
      tag: 'AI & MACHINE LEARNING',
      title: 'Where Machines Learn, Businesses Grow.',
      description: 'Harness the power of artificial intelligence and machine learning to transform your business operations. Our AI-driven solutions enable intelligent automation, predictive analytics, and data-driven decision making that drives sustainable growth and competitive advantage.',
      rightImage: '/images/main-slider/3.jpg'
    },
    {
      id: 3,
      tag: 'IoT SOLUTIONS',
      title: 'Connecting the Unconnected with IoT.',
      description: 'Bridge the gap between devices, systems, and people with our comprehensive IoT solutions. Connect and manage your entire ecosystem seamlessly, enabling real-time data collection, remote monitoring, and intelligent automation that transforms your business.',
      rightImage: '/images/main-slider/2.jpg'
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [progress, setProgress] = useState(0);

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) {
      setProgress(0);
      return;
    }

    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          return 0;
        }
        return prev + 2;
      });
    }, 100);

    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
      setProgress(0);
    }, 8000);

    return () => {
      clearInterval(progressInterval);
      clearInterval(slideInterval);
    };
  }, [isAutoPlaying, slides.length, currentSlide]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  return (
    <section className="banner-slider" id="home">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
          >
            {/* Full Width Background Image */}
            <div 
              className="slide-image"
              style={{
                backgroundImage: `url(${slide.rightImage})`
              }}
            />
            
            {/* Overlay Content */}
            <div className="slide-content">
              <div className="tag-button">
                {slide.tag}
              </div>
              <h1 className={index === currentSlide ? 'fade-in-up' : ''}>
                {slide.title}
              </h1>
              <p className="slide-description">
                {slide.description}
              </p>
              <a href="#contact" className="slide-cta-button">
                CONTACT SALES <span>&gt;</span>
              </a>
            </div>
          </div>
        ))}

        {/* Navigation Arrows */}
        <button className="slider-nav prev" onClick={prevSlide} aria-label="Previous slide">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <button className="slider-nav next" onClick={nextSlide} aria-label="Next slide">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>

        {/* Dot Indicators */}
        <div className="slider-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            >
              {index === currentSlide && isAutoPlaying && (
                <span 
                  className="dot-progress" 
                  style={{ width: `${progress}%` }}
                />
              )}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BannerSlider;
